// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__6i9_u","header":"MergedInvoice_header__2YAHX"};